var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-sm-block d-lg-inline-block"},[_c('span',{staticClass:"sau-font sm d-inline-block",class:_vm.animationClass},[_vm._t("msg")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }